/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {SerialGameAssets} from "./SerialGameAssets";
import {SerialSound} from "./sound/SerialSound";
import {SerialBackground} from "./view/SerialBackground";
import {SerialWinPresentation} from "./gameflow/SerialWinPresentation";
import {SerialNormalBetPresentation} from "./gameflow/SerialNormalBetPresentation";
import {SerialNormalResultPresentation} from "./gameflow/SerialNormalResultPresentation";
import {SerialNormalIdlePresentation} from "./gameflow/SerialNormalIdlePresentation";
import {SerialRespinIdlePresentation} from "./gameflow/SerialRespinIdlePresentation";
import {SerialModel} from "./server/SerialModel";
import {SerialLayers} from "./view/SerialLayers";
import {SerialReelController} from "./reels/SerialReelController";
import {SerialGameConfig} from "./SerialGameConfig";
import {ReelStopPresentationManager} from "./reelstoppresentation/ReelStopPresentationManager";
import {ReelStopSoundController} from "./reelstoppresentation/presentations/ReelStopSoundController";
import {WinPresentationManager} from "./winpresentation/WinPresentationManager";
import {SymbolLandingController} from "./reelstoppresentation/presentations/SymbolLandingController";
import {ScatterLandingController} from "./reelstoppresentation/presentations/ScatterLandingController";
import {InitialWinCountUp} from "./winpresentation/presentations/initial/InitialWinCountUp";
import {BigWinCountUp} from "./winpresentation/presentations/bigwin/BigWinCountUp";
import {BigWinController} from "./winpresentation/presentations/bigwin/BigWinController";
import {WildNudgeController} from "./winpresentation/presentations/WildNudgeController";
import {InitialWinController} from "./winpresentation/presentations/initial/InitialWinController";
import {NoWinSymbolsController} from "./winpresentation/presentations/NoWinSymbolsController";
import {IndividualWinController} from "./winpresentation/individual/IndividualWinController";
import {FreespinIntro} from "./screen/FreespinIntro";
import {SerialFreespinIdlePresentation} from "./gameflow/SerialFreespinIdlePresentation";
import {FreespinWinController} from "./winpresentation/presentations/FreespinWinController";
import {FreespinOutro} from "./screen/FreespinOutro";
import {FreespinEndController} from "./winpresentation/presentations/FreespinEndController";
import {BreakBankController} from "./winpresentation/presentations/BreakBankController";
import {SerialGameMode} from "./server/SerialGameMode";
import {EnhancerReelController} from "./reels/EnhancerReelController";
import {SerialSymbol} from "./symbol/SerialSymbol";
import {SerialReelView} from "./reels/SerialReelView";
import {ReelPositionController} from "./reels/ReelPositionController";
import {HiddenEnhancerReelController} from "./reels/HiddenEnhancerReelController";
import {BelowStakeWinRestriction} from "./server/BelowStakeWinRestriction";
import {ScatterToXWaysController} from "./winpresentation/presentations/ScatterToXWaysController";
import {XWaysRevealController} from "./winpresentation/presentations/XWaysRevealController";
import {SymbolWinHighlightController} from "./reelstoppresentation/presentations/SymbolWinHighlightController";
import {WaysWonCountUp} from "./winpresentation/presentations/initial/WaysWonCountUp";
import {XSplitController} from "./winpresentation/presentations/XSplitController";
import {FreespinUpdateController} from "./winpresentation/presentations/FreespinUpdateController";
import {ReelNearWinController} from "./reelstoppresentation/presentations/ReelNearWinController";
import {Ways} from "./view/Ways";
import {WinCapController} from "./screen/wincap/WinCapController";
import {WinCapIdlePresentation} from "./gameflow/WinCapIdlePresentation";
import {WinCapBetPresentation} from "./gameflow/WinCapBetPresentation";
import {WinCapWinPresentation} from "./gameflow/WinCapWinPresentation";
import {XBetController} from "./view/XBetController";
import {JumpingScatterController} from "./reelstoppresentation/presentations/JumpingScatterController";
import {InfectiousWaysControl} from "./winpresentation/presentations/InfectiousWaysControl";
import {BigWinNearWinController} from "./reelstoppresentation/presentations/BigWinNearWinController";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {Skinner} from "./Skinner";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";

export class Serial extends SlotGame {
    public static betTime:number;
    public static model:SerialModel;
    public static gameFlowController:GameFlowController;
    public static assetLoader:AssetLoader;
    public static reelPositionControls:ReelPositionController[];
    public static reels:SerialReelController[];
    public static enhancerReels:EnhancerReelController[][];
    public static reelStopPresentations:ReelStopPresentationManager;
    public static winPresentations:WinPresentationManager;
    public static initialCountUp:InitialWinCountUp;
    public static bigWinCountUp:BigWinCountUp;
    public static screenCountUp:BigWinCountUp;
    public static individualWin:IndividualWinController;
    public static freespinIntro:FreespinIntro;
    public static freespinOutro:FreespinOutro;
    public static winCapController:WinCapController;
    public static wildNudgeController:WildNudgeController;
    public static winHighlightController:SymbolWinHighlightController;
    public static reelStopSoundController:ReelStopSoundController;
    public static waysWon:WaysWonCountUp;
    public static background:SerialBackground;
    public static xBetController:XBetController;
    public static ways:Ways;
    public static jumpingScatterController:JumpingScatterController;
    public static scatters:ScatterLandingController;
    public static isActionSpinsActive:boolean=false;

    private _firstSoundPlayed:boolean = false;
    private skinner:Skinner;

    constructor() {
        super();
        const validSkinIds:string[] = [
            "ug",
            "ozzo",
            "test",
            "sweep"
        ]
        this.skinner = new Skinner(validSkinIds);
    }

    private handleSweepInit() {
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
            })
        }
    }


    public async init():Promise<NolimitPlugin> {
        const value = await super.init();

        SerialGameConfig.updateReelSets();
        Serial.model = new SerialModel(SlotGame.apiPlugin, true);
        Serial.gameFlowController = new GameFlowController(SlotGame.apiPlugin, Serial.model);
        Serial.gameFlowController.flowStateLogger.level = LogLevel.DEV;

        const idleNormal = new SerialNormalIdlePresentation();
        const normalBet = new SerialNormalBetPresentation();
        const normalResult = new SerialNormalResultPresentation();
        const freespinIdle = new SerialFreespinIdlePresentation();
        const respinIdle = new SerialRespinIdlePresentation();
        const winPres = new SerialWinPresentation();
        const winCapIdle = new WinCapIdlePresentation();
        const winCapBet = new WinCapBetPresentation();
        const winCapPres = new WinCapWinPresentation();

        Serial.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, idleNormal],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        Serial.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.RESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, respinIdle],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        Serial.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freespinIdle],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        Serial.gameFlowController.addGameModeFlowStatePresentationMap(SerialGameMode.FREESPIN_RESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, respinIdle],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        Serial.gameFlowController.addGameModeFlowStatePresentationMap(SerialGameMode.FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freespinIdle],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        Serial.gameFlowController.addGameModeFlowStatePresentationMap(SerialGameMode.FREESPIN_SUPER_RESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, respinIdle],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        Serial.gameFlowController.addGameModeFlowStatePresentationMap(SerialGameMode.CAPWIN_GAME, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, winCapIdle],
            [FlowState.BET, winCapBet],
            [FlowState.WIN, winCapPres]
        ]));
        this.handleSweepInit();
        return value;
    }

    public async getReady():Promise<NolimitPlugin> {
        //Show intro and load game assets
        const value = await super.getReady();

        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add(OpenSans.ITALIC_600);
        fontLoader.add(OpenSans.NORMAL_300);
        fontLoader.add(OpenSans.NORMAL_400);
        fontLoader.add(OpenSans.NORMAL_700);

        AssetsConfig.addToAssetsConfig(SerialGameAssets.RESOURCES_GROUPS);
        Serial.assetLoader = new AssetLoader(Serial.apiPlugin, NolimitApplication.resourcePath + "/resources/");

        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("logo_main", "resources/images/logo_main.png");
        imgLoader.add("logo_fs", "resources/images/logo_fs.png");
        imgLoader.add("logo_sfs", "resources/images/logo_sfs.png");
        imgLoader.add("S_overlay", "resources/images/S_overlay.png");


        await Promise.all([fontLoader.load(), imgLoader.load(), Serial.assetLoader.load(ResourcesGroupName.MAIN)]);

        if (this.skinner.skinId != undefined) {
            //Source folder for skin assets e.g "resources/images/skinName";
            const assetPath:string = "resources/images/";
            const replaceMap:Map<string, string> = new Map();

            if(this.skinner.skinId === "sweep"){
                replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
                replaceMap.set("Xbet", "Xbet.png");
                replaceMap.set("feature2", "intro_feature2.png");
                replaceMap.set("xbet/Switch_desktop", "Switch_desktop.png");
                replaceMap.set("xbet/Switch_mobile", "Switch_mobile.png");
            }else{
                //Intro
                replaceMap.set("logo", "intro_logo.png");
                replaceMap.set("feature1", "intro_feature1.png");
                replaceMap.set("feature2", "intro_feature2.png");
                replaceMap.set("feature3", "intro_feature3.png");

                //others
                replaceMap.set("logo_main", "logo_main.png");
                replaceMap.set("logo_fs", "logo_fs.png");
                replaceMap.set("logo_sfs", "logo_sfs.png");
                replaceMap.set("S_overlay", "S_overlay.png");


                //Action spins
                replaceMap.set("AS_GAME_LOGO", "AS_GAME_LOGO.png");
            }
            await this.skinner.loadSkin(assetPath, replaceMap)
        }

        await this.createViewsAndComponents();
        return value;
    }

    getPaytable():Promise<string> {
        const data = {
            imagePath: "screens/images/",
            sweepPath: "",
        };

        if (this.skinner.skinId != undefined) {
            if (this.skinner.skinId === "sweep") {
                data.sweepPath = `../resources/images/${this.skinner.skinId}/`;
            } else {
                data.imagePath = `../resources/images/${this.skinner.skinId}/`;
            }
        }

        return super.getPaytable().then((value: string) => {
            if (this.skinner.skinId === "sweep") {
                value = value.replace(/{{imagePath}}{{sweepPath}}/g, data.sweepPath);
            }
            value = value.replace(/{{imagePath}}/g, data.imagePath);
            return value;
        });
    }

    public async getReadyToStart():Promise<NolimitPlugin> {
        (<any>NolimitApplication.pixiApp.renderer.mask).enableScissor = true;
        //Game assets loaded, showing intro, waiting for user to start game.
        SerialSound.switchMusic(
            {name : SerialSound.MAIN_GAME_MUSIC, volume : 0},
            {name : SerialSound.MAIN_GAME_MUSIC, from : 0, to : 1, duration : 1000}
        );
        Serial.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE,(data:any)=>{
            if (data === true){
                Serial.isActionSpinsActive = true;
                Serial.individualWin.stop();
            } else {
                Serial.isActionSpinsActive = false;
            }
        });

        return await super.getReadyToStart();
    }

    public async start():Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        const value = await super.start();

        Serial.gameFlowController.start();
        Serial.xBetController.start();
        SerialSound.switchMusic({name : SerialSound.getMusicNameByMode(Serial.model.data.mode)});
        if(!Serial.model.data.nextMode.includes(GameMode.FREESPIN)) {
            SerialSound.soundPlayer.playTrack({name : SerialSound.PHONE_INTRO});
        }

        return value;
    }

    private createViewsAndComponents() {
        //Non views
        const sound = new SerialSound();
        const layers = new SerialLayers();

        //Views
        Serial.background = new SerialBackground();
        Serial.ways = new Ways();
        Serial.initialCountUp = new InitialWinCountUp();
        Serial.bigWinCountUp = new BigWinCountUp();
        Serial.screenCountUp = new BigWinCountUp();
        Serial.waysWon = new WaysWonCountUp();
        Serial.freespinIntro = new FreespinIntro();
        Serial.freespinOutro = new FreespinOutro();
        Serial.winCapController = new WinCapController();
        Serial.reelPositionControls = [];
        Serial.reels = [];
        Serial.enhancerReels = [];
        for(let i:number = 0; i < SerialGameConfig.REELS_NUM; i++) {
            const reel = new SerialReelController(i);
            Serial.reels.push(reel);
            Serial.enhancerReels.push([]);
            Serial.enhancerReels[i][0] = new EnhancerReelController(i, 0, Serial.model.parsedInitData.enhancerReelsOpenedNextSpin[i][0]);
            Serial.enhancerReels[i][1] = new HiddenEnhancerReelController(i, 1, Serial.model.parsedInitData.enhancerReelsOpenedNextSpin[i][1]);
            Serial.enhancerReels[i][5] = new HiddenEnhancerReelController(i, 5, Serial.model.parsedInitData.enhancerReelsOpenedNextSpin[i][5]);
            Serial.enhancerReels[i][6] = new EnhancerReelController(i, 6, Serial.model.parsedInitData.enhancerReelsOpenedNextSpin[i][6]);
            Serial.reelPositionControls.push(
                new ReelPositionController(i,
                    [Serial.enhancerReels[i][0].reelView, Serial.enhancerReels[i][1].reelView],
                    [Serial.enhancerReels[i][6].reelView, Serial.enhancerReels[i][5].reelView],
                    Serial.reels[i].reelView)
            );
        }
        Serial.scatters = new ScatterLandingController();
        Serial.winHighlightController = new SymbolWinHighlightController();
        Serial.reelStopSoundController = new ReelStopSoundController();
        Serial.jumpingScatterController = new JumpingScatterController();
        Serial.reelStopPresentations = new ReelStopPresentationManager([
            Serial.scatters,
            new SymbolLandingController(),
            new ReelNearWinController(),
            new BigWinNearWinController(),
            Serial.winHighlightController,
            Serial.reelStopSoundController,
            Serial.jumpingScatterController
        ]);
        Serial.wildNudgeController = new WildNudgeController();
        Serial.winPresentations = new WinPresentationManager([
            Serial.wildNudgeController,
            new InfectiousWaysControl(),
            new ScatterToXWaysController(),
            new XWaysRevealController(),
            new XSplitController(),
            new NoWinSymbolsController(),
            new InitialWinController(),
            new BigWinController(),
            new FreespinWinController(),
            new FreespinUpdateController(),
            new FreespinEndController(),
            new BreakBankController()
        ]);
        Serial.individualWin = new IndividualWinController();

        if(Serial.model.isRestore && Serial.model.parsedInitData.showTotalWin) {
            SlotGame.keypadPlugin.setWin(Serial.model.parsedInitData.totalWin, true, BelowStakeWinRestriction.isWinBelowStake());
        }
        Serial.background.setMode(GameMode.NORMAL);
        // If restore, can be handled in these constructors directly.
    }

    public static getSymbol(reelId:number, symId:number, getVisibleStackedSymbol:boolean = true):SerialSymbol {
        switch(symId) {
            case 0:
            case 1:
            case 5:
            case 6:
                return Serial.enhancerReels[reelId][symId].getSymbol();
            default:
                return Serial.reels[reelId].getSymbol(symId - 2, false, getVisibleStackedSymbol);
        }
    }

    public static getReelView(reelId:number, symId:number):SerialReelView {
        switch(symId) {
            case 0:
            case 1:
            case 5:
            case 6:
                return Serial.enhancerReels[reelId][symId].reelView;
            default:
                return Serial.reels[reelId].reelView;
        }
    }


    getNoWinGameData():any {
        return {
            "accumulatedRoundWin" : 0,
            "betWayWins" : [],
            "boostedBetPlayed" : false,
            "bottomRowReelString" : [
                ["M3", "M1"],
                ["M5", "M1"],
                ["M1", "M2"],
                ["M5", "M1"],
                ["M1", "M5"]
            ],
            "brokeTheBank" : false,
            "enhancerOpenedNextSpin" : [
                [false, false],
                [false, false],
                [false, false],
                [false, false],
                [false, false]
            ],
            "evaluatedArea" : [
                ['BLANK', 'BLANK', 'L3', 'M4', 'L3', 'BLANK', 'BLANK'],
                ['BLANK', 'BLANK', 'M5', 'M1', 'L4', 'BLANK', 'BLANK'],
                ['BLANK', 'BLANK', 'L3', 'L4', 'L5', 'BLANK', 'BLANK'],
                ['BLANK', 'BLANK', 'L5', 'L3', 'L4', 'BLANK', 'BLANK'],
                ['BLANK', 'BLANK', 'L1', 'M3', 'M5', 'BLANK', 'BLANK']
            ],
            "evaluatedAreaBeforeFeature" : [
                ['M3', 'M3', 'L3', 'M4', 'L3', 'M3', 'M1'],
                ['M1', 'M1', 'M5', 'M1', 'L4', 'M5', 'M1'],
                ['M5', 'M1', 'L3', 'L4', 'L5', 'M1', 'M2'],
                ['M5', 'M5', 'L5', 'L3', 'L4', 'M5', 'M1'],
                ['M3', 'M5', 'L1', 'M3', 'M5', 'M1', 'M5']
            ],
            "featureBuyTimesBetValue" : [
                {"name" : 'FREESPIN', "type" : 'FREESPIN', "price" : 78},
                {"name" : 'SUPER_FREESPIN', "type" : 'FREESPIN', "price" : 480},
                {"name" : 'LUCKY_DRAW', "type" : 'FREESPIN', "price" : 279},
                {"name" : 'BOOSTED_BET', "type" : 'BOOSTED_BET', "price" : 1.2}
            ],
            "freespinsLeft" : 0,
            "infectiousWays" : [],
            "lockSymbolsFromPreviousSpinForQA" : [null, null, null, null, null],
            "lockedSymbolsNextSpin" : [
                [null, null, null, null, null, null, null],
                [null, null, null, null, null, null, null],
                [null, null, null, null, null, null, null],
                [null, null, null, null, null, null, null],
                [null, null, null, null, null, null, null]
            ],
            "maxWinLevel" : -1,
            "maximumWinAchieved" : false,
            "mode" : "NORMAL",
            "multiplierOnReel" : [0, 0, 0, 0, 0],
            "mysterySymbolReveal" : "",
            "nextMode" : "NORMAL",
            "numberOfFreespinsPlayed" : 0,
            "playedBetValue" : 1,
            "reels" : [
                ['L4', 'L3', 'M4', 'L3', 'L3'],
                ['M2', 'M5', 'M1', 'L4', 'M3'],
                ['L2', 'L3', 'L4', 'L5', 'L2'],
                ['L2', 'L5', 'L3', 'L4', 'L1'],
                ['M5', 'L1', 'M3', 'M5', 'L5']
            ],
            "serverPickChoiceForQA" : -1,
            "specialSymbolsList" : [],
            "symbolSizes" : [
                [0, 0, 0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0, 0, 0],
                [0, 0, 0, 0, 0, 0, 0]
            ],
            "topRowReelString" : [
                ["M3", "M3"],
                ["M1", "M1"],
                ["M5", "M1"],
                ["M5", "M5"],
                ["M3", "M5"]
            ],
            "totalSpinWinnings" : 0,
            "totalWays" : 243,
            "wasFeatureBuy" : false,
            "xWaysDataList" : [],
        };
    }
}